export default function Loading() {
    return (
        <div style={{display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
            <img src='/loading.gif' style={{width: '64px', height: '64px'}}/>
        </div>
    );
};
